import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_34 implements Validator {

	public static id = 'CTRL_34';
	private message = 'error.ctr_34';


	public LOG: LogService = new LogService(CTRL_34);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_34.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const urlAdmEtTechWithStepId = map.get(ctrl.value.rgCtrls.urlAdmEtTech);
				const urlAdmOuTechAdmWithStepId = map.get(ctrl.value.rgCtrls.urlAdmOuTechAdm);
				const urlAdmOuTechTechWithStepId = map.get(ctrl.value.rgCtrls.urlAdmOuTechTech);
				const urlDocumentWithStepId = map.get(ctrl.value.rgCtrls.urlDocument);
				const urlEnvoiWithStepId = map.get(ctrl.value.rgCtrls.urlEnvoi);
				const urlRensWithStepId = map.get(ctrl.value.rgCtrls.urlRens);
				const urlAdmEtTechCtrl = form.controls[urlAdmEtTechWithStepId];
    const urlAdmOuTechAdmCtrl = form.controls[urlAdmOuTechAdmWithStepId];
				const urlAdmOuTechTechCtrl = form.controls[urlAdmOuTechTechWithStepId];
    const urlDocumentCtrl = form.controls[urlDocumentWithStepId];
				const urlEnvoiCtrl = form.controls[urlEnvoiWithStepId];
    const urlRensCtrl = form.controls[urlRensWithStepId];
				if (
				(urlAdmEtTechCtrl && this.isCorrect(urlAdmEtTechCtrl.value) === null) ||
				(urlAdmOuTechAdmCtrl && this.isCorrect(urlAdmOuTechAdmCtrl.value)  === null) ||
				(urlAdmOuTechTechCtrl && this.isCorrect(urlAdmOuTechTechCtrl.value) === null) ||
				(urlDocumentCtrl && this.isCorrect(urlDocumentCtrl.value) === null) ||
				(urlEnvoiCtrl && this.isCorrect(urlEnvoiCtrl.value) === null) ||
				(urlRensCtrl && this.isCorrect(urlRensCtrl.value) === null) ) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
			}
		}
	}

	isCorrect(value){
		return value?value.match('(((http|HTTP|https|HTTPS|ftp|FTP|ftps|FTPS|sftp|SFTP)://)|((w|W){3}(\\d)?\\.))[\\w\\?!\\./:;,\\-_=#+*%@\"\\(\\)&amp;]+'):false;
	}
}
